"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Error_MetadataEntry = exports.Error_LocalizedMessage = exports.Error_DebugInfo = exports.Error_Help_Link = exports.Error_Help = exports.Error_BadRequest_FieldViolation = exports.Error_BadRequest = exports.Error = void 0;
/* eslint-disable */
const long_1 = __importDefault(require("long"));
const minimal_1 = __importDefault(require("protobufjs/minimal"));
function createBaseError() {
    return {
        errorCode: 0,
        errorId: "",
        reason: "",
        domain: "",
        message: "",
        details: "",
        metadata: {},
        badRequest: undefined,
        debugInfo: undefined,
        help: undefined,
        localizedMessages: [],
        errors: [],
    };
}
exports.Error = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.errorCode !== 0) {
            writer.uint32(8).uint64(message.errorCode);
        }
        if (message.errorId !== "") {
            writer.uint32(18).string(message.errorId);
        }
        if (message.reason !== "") {
            writer.uint32(26).string(message.reason);
        }
        if (message.domain !== "") {
            writer.uint32(34).string(message.domain);
        }
        if (message.message !== "") {
            writer.uint32(42).string(message.message);
        }
        if (message.details !== "") {
            writer.uint32(50).string(message.details);
        }
        Object.entries(message.metadata).forEach(([key, value]) => {
            exports.Error_MetadataEntry.encode({ key: key, value }, writer.uint32(74).fork()).ldelim();
        });
        if (message.badRequest !== undefined) {
            exports.Error_BadRequest.encode(message.badRequest, writer.uint32(82).fork()).ldelim();
        }
        if (message.debugInfo !== undefined) {
            exports.Error_DebugInfo.encode(message.debugInfo, writer.uint32(90).fork()).ldelim();
        }
        if (message.help !== undefined) {
            exports.Error_Help.encode(message.help, writer.uint32(802).fork()).ldelim();
        }
        for (const v of message.localizedMessages) {
            exports.Error_LocalizedMessage.encode(v, writer.uint32(1602).fork()).ldelim();
        }
        for (const v of message.errors) {
            exports.Error.encode(v, writer.uint32(4002).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 8) {
                        break;
                    }
                    message.errorCode = longToNumber(reader.uint64());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.errorId = reader.string();
                    continue;
                case 3:
                    if (tag !== 26) {
                        break;
                    }
                    message.reason = reader.string();
                    continue;
                case 4:
                    if (tag !== 34) {
                        break;
                    }
                    message.domain = reader.string();
                    continue;
                case 5:
                    if (tag !== 42) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
                case 6:
                    if (tag !== 50) {
                        break;
                    }
                    message.details = reader.string();
                    continue;
                case 9:
                    if (tag !== 74) {
                        break;
                    }
                    const entry9 = exports.Error_MetadataEntry.decode(reader, reader.uint32());
                    if (entry9.value !== undefined) {
                        message.metadata[entry9.key] = entry9.value;
                    }
                    continue;
                case 10:
                    if (tag !== 82) {
                        break;
                    }
                    message.badRequest = exports.Error_BadRequest.decode(reader, reader.uint32());
                    continue;
                case 11:
                    if (tag !== 90) {
                        break;
                    }
                    message.debugInfo = exports.Error_DebugInfo.decode(reader, reader.uint32());
                    continue;
                case 100:
                    if (tag !== 802) {
                        break;
                    }
                    message.help = exports.Error_Help.decode(reader, reader.uint32());
                    continue;
                case 200:
                    if (tag !== 1602) {
                        break;
                    }
                    message.localizedMessages.push(exports.Error_LocalizedMessage.decode(reader, reader.uint32()));
                    continue;
                case 500:
                    if (tag !== 4002) {
                        break;
                    }
                    message.errors.push(exports.Error.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j;
        const message = createBaseError();
        message.errorCode = (_a = object.errorCode) !== null && _a !== void 0 ? _a : 0;
        message.errorId = (_b = object.errorId) !== null && _b !== void 0 ? _b : "";
        message.reason = (_c = object.reason) !== null && _c !== void 0 ? _c : "";
        message.domain = (_d = object.domain) !== null && _d !== void 0 ? _d : "";
        message.message = (_e = object.message) !== null && _e !== void 0 ? _e : "";
        message.details = (_f = object.details) !== null && _f !== void 0 ? _f : "";
        message.metadata = Object.entries((_g = object.metadata) !== null && _g !== void 0 ? _g : {}).reduce((acc, [key, value]) => {
            if (value !== undefined) {
                acc[key] = String(value);
            }
            return acc;
        }, {});
        message.badRequest = (object.badRequest !== undefined && object.badRequest !== null)
            ? exports.Error_BadRequest.fromPartial(object.badRequest)
            : undefined;
        message.debugInfo = (object.debugInfo !== undefined && object.debugInfo !== null)
            ? exports.Error_DebugInfo.fromPartial(object.debugInfo)
            : undefined;
        message.help = (object.help !== undefined && object.help !== null)
            ? exports.Error_Help.fromPartial(object.help)
            : undefined;
        message.localizedMessages = ((_h = object.localizedMessages) === null || _h === void 0 ? void 0 : _h.map((e) => exports.Error_LocalizedMessage.fromPartial(e))) || [];
        message.errors = ((_j = object.errors) === null || _j === void 0 ? void 0 : _j.map((e) => exports.Error.fromPartial(e))) || [];
        return message;
    },
};
function createBaseError_BadRequest() {
    return { errors: [] };
}
exports.Error_BadRequest = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.errors) {
            exports.Error_BadRequest_FieldViolation.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_BadRequest();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.errors.push(exports.Error_BadRequest_FieldViolation.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_BadRequest.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseError_BadRequest();
        message.errors = ((_a = object.errors) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Error_BadRequest_FieldViolation.fromPartial(e))) || [];
        return message;
    },
};
function createBaseError_BadRequest_FieldViolation() {
    return { field: "", description: "" };
}
exports.Error_BadRequest_FieldViolation = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.field !== "") {
            writer.uint32(10).string(message.field);
        }
        if (message.description !== "") {
            writer.uint32(18).string(message.description);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_BadRequest_FieldViolation();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.field = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_BadRequest_FieldViolation.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseError_BadRequest_FieldViolation();
        message.field = (_a = object.field) !== null && _a !== void 0 ? _a : "";
        message.description = (_b = object.description) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseError_Help() {
    return { links: [] };
}
exports.Error_Help = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.links) {
            exports.Error_Help_Link.encode(v, writer.uint32(10).fork()).ldelim();
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_Help();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.links.push(exports.Error_Help_Link.decode(reader, reader.uint32()));
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_Help.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a;
        const message = createBaseError_Help();
        message.links = ((_a = object.links) === null || _a === void 0 ? void 0 : _a.map((e) => exports.Error_Help_Link.fromPartial(e))) || [];
        return message;
    },
};
function createBaseError_Help_Link() {
    return { description: "", url: "" };
}
exports.Error_Help_Link = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.description !== "") {
            writer.uint32(10).string(message.description);
        }
        if (message.url !== "") {
            writer.uint32(18).string(message.url);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_Help_Link();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.description = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.url = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_Help_Link.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseError_Help_Link();
        message.description = (_a = object.description) !== null && _a !== void 0 ? _a : "";
        message.url = (_b = object.url) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseError_DebugInfo() {
    return { stackTrace: [], detail: "" };
}
exports.Error_DebugInfo = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        for (const v of message.stackTrace) {
            writer.uint32(10).string(v);
        }
        if (message.detail !== "") {
            writer.uint32(18).string(message.detail);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_DebugInfo();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.stackTrace.push(reader.string());
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.detail = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_DebugInfo.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseError_DebugInfo();
        message.stackTrace = ((_a = object.stackTrace) === null || _a === void 0 ? void 0 : _a.map((e) => e)) || [];
        message.detail = (_b = object.detail) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseError_LocalizedMessage() {
    return { locale: "", message: "" };
}
exports.Error_LocalizedMessage = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.locale !== "") {
            writer.uint32(10).string(message.locale);
        }
        if (message.message !== "") {
            writer.uint32(18).string(message.message);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_LocalizedMessage();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.locale = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.message = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_LocalizedMessage.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseError_LocalizedMessage();
        message.locale = (_a = object.locale) !== null && _a !== void 0 ? _a : "";
        message.message = (_b = object.message) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
function createBaseError_MetadataEntry() {
    return { key: "", value: "" };
}
exports.Error_MetadataEntry = {
    encode(message, writer = minimal_1.default.Writer.create()) {
        if (message.key !== "") {
            writer.uint32(10).string(message.key);
        }
        if (message.value !== "") {
            writer.uint32(18).string(message.value);
        }
        return writer;
    },
    decode(input, length) {
        const reader = input instanceof minimal_1.default.Reader ? input : minimal_1.default.Reader.create(input);
        let end = length === undefined ? reader.len : reader.pos + length;
        const message = createBaseError_MetadataEntry();
        while (reader.pos < end) {
            const tag = reader.uint32();
            switch (tag >>> 3) {
                case 1:
                    if (tag !== 10) {
                        break;
                    }
                    message.key = reader.string();
                    continue;
                case 2:
                    if (tag !== 18) {
                        break;
                    }
                    message.value = reader.string();
                    continue;
            }
            if ((tag & 7) === 4 || tag === 0) {
                break;
            }
            reader.skipType(tag & 7);
        }
        return message;
    },
    create(base) {
        return exports.Error_MetadataEntry.fromPartial(base !== null && base !== void 0 ? base : {});
    },
    fromPartial(object) {
        var _a, _b;
        const message = createBaseError_MetadataEntry();
        message.key = (_a = object.key) !== null && _a !== void 0 ? _a : "";
        message.value = (_b = object.value) !== null && _b !== void 0 ? _b : "";
        return message;
    },
};
const tsProtoGlobalThis = (() => {
    if (typeof globalThis !== "undefined") {
        return globalThis;
    }
    if (typeof self !== "undefined") {
        return self;
    }
    if (typeof window !== "undefined") {
        return window;
    }
    if (typeof global !== "undefined") {
        return global;
    }
    throw "Unable to locate global object";
})();
function longToNumber(long) {
    if (long.gt(Number.MAX_SAFE_INTEGER)) {
        throw new tsProtoGlobalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
    }
    return long.toNumber();
}
if (minimal_1.default.util.Long !== long_1.default) {
    minimal_1.default.util.Long = long_1.default;
    minimal_1.default.configure();
}
//# sourceMappingURL=error.js.map